import { Row, Col } from 'reactstrap';
import cityHooks from 'hooks/city.hooks';
import usersHooks from 'hooks/users.hooks';

import allons from '../../assets/images/allons.png';
import logoDsa from '../../assets/images/logo/logo_defisansautosolo-17ee7.png';
import logoGreenplay from '../../assets/images/logo/logo_greenplay-d2122.png';
import logoSherbrooke from '../../assets/images/logo/logo_greenplaysherbrooke.png';

export default function projectLogo({ isDashboard }) {

    const project = import.meta.env.VITE_FIREBASE_PROJECT_ID;
    const { details, userId } = usersHooks.useExternalUser();
    const { limitSettings } = cityHooks.useFetchCityLimitSettings(details?.cityId || userId);
    const shouldUseAllonsLogo = Boolean(
        limitSettings?.c19_carpooling_app?.granted && !limitSettings?.c19_carpooling_app?.greenplay_addon
    );

    let logo;

    switch (project) {

        case "defisansautosolo-17ee7":
            logo = logoDsa;
            break;
        case "greenplay-d2122":
            logo = logoGreenplay;
            break;
        case "greenplay-test-d85fa":
            logo = logoGreenplay;
            break;
        case "greenplaysherbrooke":
            logo = logoSherbrooke;
            break;
        default:
            logo = logoGreenplay;
            break;
    }

    const resolvedLogo = shouldUseAllonsLogo ? allons : logo;
    const logoStyle = shouldUseAllonsLogo ? { maxWidth: '80px', width: 'auto' } : undefined;

    return (
        isDashboard ?
            <div>
                <Col>
                    <div className="text-center">
                        <img src={resolvedLogo} className="logo-dashboard" alt="logo" style={logoStyle} />
                    </div>
                </Col>
            </div>

            :
            <div className="text-center">
                <img src={resolvedLogo} className="logo" alt="logo" style={logoStyle} />
            </div>
    )

}
